import ReviewProfileModal from './ReviewProfileModal'

export default ReviewProfileModal
